
import {
  COMPANY,
  COMPANY_STAFFS,
  COMPANY_PARTS,
  CREATE_PART,
  UPDATE_COMPANY_STAFFS,
  UPDATE_DELETE_PART,
  IMPORT_STAFFS,
  IMPORT_STAFFS_ATTENDENCE,
  COMPANY_STAFFS_ATTENDENCE,
  EMAIL_TIME_SUMMARY,
} from "../../constants/apis";

import { replaceMultiple, getUrl } from "../../utilities/helpers";


export const fetchCompanies =
  (query=undefined) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(COMPANY, query)
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const addCompany =
  (payload) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .post(COMPANY, payload)
      .then((result) => {
        result;
      })
      .catch((error) => {
        throw error;
      });
  };

export const updateCompany =
  (uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .put(`${COMPANY}/${uuid}`, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const deleteCompany =
  (uuid) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .delete(`${COMPANY}/${uuid}`)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };


export const fetchCompanyStaffs =
  (uuid, query) =>
  (dispatch, getState, { apiReport }) => {
    let basePath = replaceMultiple(COMPANY_STAFFS, {
      "{{uuid}}": uuid,
    });
    const finalUrlPath = getUrl(basePath, query);
    return apiReport
      .get(finalUrlPath)
      .then((result) => result)
      .catch((error) => {
        console.error("Error fetching company staffs:", error);
        throw error;
      });
  };

  export const fetchCompanyStaffsAttendence =
  (uuid, query) =>
  (dispatch, getState, { apiReport }) => {
    let basePath = replaceMultiple(COMPANY_STAFFS_ATTENDENCE, {
      "{{uuid}}": uuid,
    });
    const finalUrlPath = getUrl(basePath, query);
    return apiReport
      .get(finalUrlPath)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

  export const importStaff =
  (company_uuid, payload)=>
    (dispatch, getState,{apiReport})=>{
    const url = replaceMultiple(IMPORT_STAFFS, {"{{uuid}}":company_uuid});
    return apiReport
    .post(url, payload)
    .then((result)=>result)
    .catch((error)=>{
      throw error
    })
  }

    export const importAttendence =
  (company_uuid, payload)=>
    (dispatch, getState,{apiReport})=>{
    const url = replaceMultiple(IMPORT_STAFFS_ATTENDENCE, {"{{uuid}}":company_uuid});
    return apiReport
    .post(url, payload)
    .then((result)=>result)
    .catch((error)=>{
      throw error
    })
  }

export const createCompanyStaffs =
  (company_uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(COMPANY_STAFFS, {
      "{{uuid}}": company_uuid,
    });
    return apiReport
      .post(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const updateCompanyStaffs =
  (company_uuid, staff_id, payload) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(UPDATE_COMPANY_STAFFS, {
      "{{uuid}}": company_uuid,
      "{{staff_id}}": staff_id,
    });
    return apiReport
      .put(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchCompanyParts =
  (uuid, query) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(
      replaceMultiple(COMPANY_PARTS, {
        "{{uuid}}": uuid,
      }),
      query 
    );
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const createCompanyParts =
  (companyUuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(CREATE_PART, {
      "{{company_uuid}}": companyUuid,
    });
    return apiReport
      .post(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const updateCompanyParts =
  (uuid, companyUuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(UPDATE_DELETE_PART, {
      "{{uuid}}": uuid,
      "{{company_uuid}}": companyUuid,
    });
    return apiReport
      .put(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const deleteCompanyParts =
  (uuid, companyUuid) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(UPDATE_DELETE_PART, {
      "{{uuid}}": uuid,
      "{{company_uuid}}": companyUuid,
    });
    return apiReport
      .delete(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
